import React from 'react';
import Stats from '../../common/Stats';
import { getConfiguration } from '../../data/utils/configuration';
import { appConfig } from '../../appConfig';

function Standings(props) {
    const url = getConfiguration()['ps']['clt'].replace('{{seasonId}}',props.data).replace('{{sportId}}',props.sport).replace('{{lang}}',appConfig['LANGUAGE']);
    return (        
        <div className="overlay-container">
            <Stats url={url}/>        
        </div>
    )
}
export default Standings;